import React from "react";
import { Check } from "lucide-react";

export function RequirementsList({ requirements }) {
  const req = requirements || {};
  const items = [];

  if (req.duration_exact) items.push(`Exactly ${req.duration_exact} seconds`);
  else if (req.duration_min || req.duration_max)
    items.push(`${req.duration_min || 0}–${req.duration_max || "?"} seconds`);
  if (req.aspect_ratio) items.push(`Aspect ratio ${req.aspect_ratio}`);
  (req.subject_required || []).forEach((s) => items.push(`${s} must appear`));
  if (req.caption_required)
    items.push(
      "Captions required" +
        (req.caption_keywords?.length ? ` (mention ${req.caption_keywords.join(", ")})` : "")
    );
  (req.required_words || []).forEach((w) => items.push(`Must include text: "${w}"`));
  (req.required_hashtags || []).forEach((h) => items.push(`Use hashtag ${h}`));
  if (req.title_required) items.push("Title required");
  if (req.watermark_required) items.push("Watermark required");
  if (req.logo_required) items.push("Logo required");
  if (req.subtitle_required) items.push("Subtitles required");
  if (req.language) items.push(`Language: ${req.language}`);
  if (req.number_of_clips) items.push(`${req.number_of_clips} clips`);
  (req.platform_requirements || []).forEach((p) => items.push(`Post to ${p}`));
  (req.prohibited_words || []).forEach((w) => items.push(`Prohibited: ${w}`));
  (req.prohibited_subjects || []).forEach((s) => items.push(`No ${s}`));
  (req.content_themes || []).forEach((t) => items.push(`Theme: ${t}`));
  if (req.source_restrictions) items.push(`Source: ${req.source_restrictions}`);
  if (req.formatting_notes) items.push(req.formatting_notes);

  if (items.length === 0)
    return <p className="text-zinc-500 text-sm">No structured requirements detected.</p>;

  return (
    <div className="space-y-2.5" data-testid="requirements-list">
      {items.map((it, i) => (
        <div key={i} className="flex items-start gap-3">
          <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center mt-0.5 shrink-0">
            <Check className="w-3 h-3 text-emerald-400" strokeWidth={3} />
          </div>
          <span className="text-sm text-zinc-200">{it}</span>
        </div>
      ))}
    </div>
  );
}
